// version number for displaying in FE
export const configVersion = Object.freeze({
  DEV: 'V1.1.070.1',
  STABLE: 'V1.1.070.2',
  STAGING: 'V1.1.070.3',
  PROD: 'V1.1.070',
});
